export function getStatsigUser(baseUser = {}) {
    const user = baseUser && typeof baseUser === "object" ? { ...baseUser } : {};
    const userId = new URLSearchParams(window.location.search || "").get("statsig_user_id")?.trim();
    if (userId) {
        user.userID = userId;
    }
    return user;
}
